import { Accordion, Card, Heading, Paragraph } from '@zillow/constellation-10';
import { OutstandingBalanceItems } from './OutstandingBalanceItems.component';
import type { LateRentModel } from '@renter-hub/models/Types';

type Props = {
  transactions: Array<LateRentModel>;
  payLateRentPaymentOnClick: (scheduleMonth: string) => void;
};

export const OutstandingBalanceCard = (props: Props) => (
  <Card css={{ padding: 'default', marginBottom: 'loose' }} elevated={false}>
    <Heading level={3} textStyle="heading-xs">
      Outstanding Balance
    </Heading>
    <Paragraph css={{ marginBottom: 'loose', marginTop: 'default' }}>You have a payment that is past due</Paragraph>
    <Accordion.Root>
      <Accordion.Item value="outsanding-balance-accordion">
        <Accordion.Header css={{ padding: '12px 16px' }}>
          <Heading level={6}>Your past due payments</Heading>
        </Accordion.Header>
        <Accordion.Panel css={{ padding: '12px 16px' }}>
          <OutstandingBalanceItems
            transactions={props.transactions}
            payLateRentPaymentOnClick={props.payLateRentPaymentOnClick}
          />
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion.Root>
  </Card>
);
